export const MIN_PASSWORD_LENGTH = 8

const AUTH_LOCALSTORAGE_KEY: string = 'WASTEPAY_AUTH_TOKEN'
export const AFTER_LOGIN_PARAM_KEY = 'after-login-path'

export const setAuthToken = (authToken: string): void => {
  window.localStorage.setItem(AUTH_LOCALSTORAGE_KEY, authToken)
}

export const retrieveAuthToken = (): string | null => {
  if (typeof window === 'undefined') { return null }
  return window.localStorage.getItem(AUTH_LOCALSTORAGE_KEY) ?? null
}

export const clearAuthToken = (): void => { window.localStorage.removeItem(AUTH_LOCALSTORAGE_KEY) }

export function determineFailedAuthRedirectPath (): string {
  const currentPath = `${window.location.pathname}${window.location.search}`
  const searchParams = new URLSearchParams()
  searchParams.set(AFTER_LOGIN_PARAM_KEY, currentPath)
  return `/auth/login?${searchParams.toString()}`
}

export function handleStorageChange (event: StorageEvent): void {
  const isCorrectKey = event.key === AUTH_LOCALSTORAGE_KEY
  const isRemoved = event.newValue === null
  if (isCorrectKey && isRemoved) {
    window.location.href = '/'
  }
}
